import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAuth } from '../../auth/useAuth';
export function AdminHome() {
    const { player } = useAuth();
    return (_jsxs("div", { children: [_jsx("h1", { className: "font-serif text-3xl tracking-[-0.02em]", children: "Admin" }), _jsxs("p", { className: "mt-3 text-foreground-soft text-sm", children: ["Welcome, ", player?.display_name, ". Phase 3 lands tournament + match management here."] })] }));
}
